;
// converte preço formatado (ex: "R$ 24,90") pra centavos, pra somar com o subtotal do carrinho
window.parseMoneyToCents = function (str) {
    if (!str) return 0;
    var digits = String(str).replace(/[^\d,.]/g, '');
    digits = digits.replace(/\.(?=\d{3}(\D|$))/g, '');
    digits = digits.replace(',', '.');
    var value = parseFloat(digits);
    return isNaN(value) ? 0 : Math.round(value * 100);
};

jQuery(function ($) {

    function inputHandler(masks, max, event) {
        var c = event.target;
        var v = c.value.replace(/\D/g, "");
        var m = c.value.length > max ? 1 : 0;
        VMasker(c).unMask();
        VMasker(c).maskPattern(masks[m]);
        c.value = VMasker.toPattern(v, masks[m]);
    }

    // mantém o #variantid da calculadora sincronizado com o tamanho selecionado
    // no formulário de compra (antes ficava travado na variante do carregamento da página)
    $(document).on('change', 'input[name="id"].product-variant-id', function() {
        $('#variantid').val($(this).val());
    });

    // controla o item temporário que a calculadora precisa colocar no carrinho
    // pra Shopify conseguir cotar frete (API nativa só calcula em cima do carrinho real).
    var tempCartItem = {
        addingInFlight: false,
        variantId: null,
        failsafeTimer: null
    };

    function removeTempCartItem() {
        if (!tempCartItem.variantId) return;
        var variantToRemove = tempCartItem.variantId;
        tempCartItem.variantId = null;
        if (tempCartItem.failsafeTimer) {
            clearTimeout(tempCartItem.failsafeTimer);
            tempCartItem.failsafeTimer = null;
        }
        Shopify.removeItem(variantToRemove);
    }

    // A cotação de frete da Shopify é assíncrona em duas etapas:
    // POST /cart/prepare_shipping_rates.json só avisa que aceitou o pedido (202).
    // O resultado de verdade só existe fazendo polling em
    // GET /cart/async_shipping_rates.json até ele deixar de responder 202.
    // O widget nativo (Shopify.Cart.ShippingCalculator) não faz esse polling — ele
    // trata o 202 do prepare como se já fosse a resposta final, por isso nunca
    // achava tarifa nenhuma. A cotação em si funciona (confirmado testando a mão);
    // faltava o polling.
    var ratesTemplateSource = document.getElementById('shipping-calculator-response-template');
    var ratesTemplate = ratesTemplateSource ? _.template(ratesTemplateSource.innerHTML) : null;

    function renderRatesResult(success, rawRates) {
        $(".get-rates-custom").removeClass("loading");
        $(".get-rates-custom").attr('value', 'Calcular');

        var rates = (rawRates || []).map(function (rate) {
            var cents = Math.round(parseFloat(rate.price) * 100);
            if (isNaN(cents)) cents = 0;
            var formatted = {};
            for (var key in rate) {
                if (Object.prototype.hasOwnProperty.call(rate, key)) formatted[key] = rate[key];
            }
            formatted.price = Shopify.formatMoney(cents, window.moneyformat);
            return formatted;
        });

        if (ratesTemplate) {
            $('#wrapper-response').html(ratesTemplate({ success: success, rates: rates }));
        }
        removeTempCartItem();
    }

    function pollAsyncShippingRates(query, attemptsLeft) {
        $.ajax({
            url: '/cart/async_shipping_rates.json?' + query,
            method: 'GET',
            dataType: 'json'
        }).done(function (data, textStatus, jqXHR) {
            if (jqXHR.status === 202) {
                if (attemptsLeft <= 0) {
                    renderRatesResult(false, []);
                    return;
                }
                setTimeout(function () {
                    pollAsyncShippingRates(query, attemptsLeft - 1);
                }, 1000);
                return;
            }
            renderRatesResult(true, (data && data.shipping_rates) || []);
        }).fail(function () {
            renderRatesResult(false, []);
        });
    }

    function fetchShippingRates(zip, country, province) {
        var query = $.param({
            'shipping_address[zip]': zip,
            'shipping_address[country]': country,
            'shipping_address[province]': province
        });
        $.ajax({
            url: '/cart/prepare_shipping_rates.json?' + query,
            method: 'POST'
        }).always(function () {
            pollAsyncShippingRates(query, 10);
        });
    }

    var carregaFrete = function(cep) {
        if($("#address_zip").val().length != 9) {
            alert("Digite um cep válido")
        }else{
            $(".get-rates-custom").addClass("loading");
            $("#shipping-calculator2 .loading").addClass("load");
            $(".get-rates-custom").attr('value', 'Calculando...');

            $.getJSON("//viacep.com.br/ws/" + cep + "/json/?callback=?", function(dados) {
                if (!("erro" in dados)) {
                    if(!$("#shipping-calculator2.shiping-loaded")[0]) {

                        $("#shipping-calculator2").addClass("shiping-loaded")
                    }
                    var state;
                    var uf = dados.uf.toUpperCase();
                    switch (uf) {
                        case "AC" :	state = "Acre";					break;
                        case "AL" :	state = "Alagoas";				break;
                        case "AM" :	state = "Amazonas";				break;
                        case "AP" :	state = "Amapá";				break;
                        case "BA" :	state = "Bahia";				break;
                        case "CE" :	state = "Ceará";				break;
                        case "DF" :	state = "Distrito Federal";		break;
                        case "ES" :	state = "Espírito Santo";		break;
                        case "GO" :	state = "Goiás";				break;
                        case "MA" :	state = "Maranhão";				break;
                        case "MG" :	state = "Minas Gerais";			break;
                        case "MS" :	state = "Mato Grosso do Sul";	break;
                        case "MT" :	state = "Mato Grosso";			break;
                        case "PA" :	state = "Pará";					break;
                        case "PB" :	state = "Paraíba";				break;
                        case "PE" :	state = "Pernambuco";			break;
                        case "PI" :	state = "Piauí";				break;
                        case "PR" :	state = "Paraná";				break;
                        case "RJ" :	state = "Rio de Janeiro";		break;
                        case "RN" :	state = "Rio Grande do Norte";	break;
                        case "RO" :	state = "Rondônia";				break;
                        case "RR" :	state = "Roraima";				break;
                        case "RS" :	state = "Rio Grande do Sul";	break;
                        case "SC" :	state = "Santa Catarina";		break;
                        case "SE" :	state = "Sergipe";				break;
                        case "SP" :	state = "São Paulo";			break;
                        case "TO" :	state = "Tocantíns";			break;
                      }
                    $('[name="address[province]"] option[value="' + state + '"]').prop('selected', true);
                    $("#shipping-address-confirm").text("Entregando em: " + dados.localidade + " - " + uf).show();
                    fetchShippingRates(cep, 'Brazil', state);
                } else {
                    $("#shipping-address-confirm").hide();
                    alert("CEP não encontrado");
                    $(".get-rates-custom").removeClass("loading");
                    $(".get-rates-custom").attr('value', 'Calcular');
                    removeTempCartItem();
                }
            }).fail(function(jqXHR) {
                alert("Consulta de CEP indisponivel no momento")
                $(".get-rates-custom").removeClass("loading");
                $(".get-rates-custom").attr('value', 'Calcular');
                removeTempCartItem();
            });
        }
    }

    $(document).on('keypress', '#address_zip', function(event) {
        if(event.keyCode == 13) {
            event.preventDefault();
            $(".get-rates-custom").trigger("click")
        }
    });

    $(document).on('click', '.get-rates-custom', function() {
        var variantid = $("#variantid");
        var variantvalue = variantid.length ? variantid.val() : '';
        if(variantid[0] && variantvalue) {
            if (tempCartItem.addingInFlight) {
                return;
            }

            if (tempCartItem.variantId) {
                // já tem item temporário no carrinho pra essa consulta, só recalcula
                carregaFrete($('#address_zip').val());
                return;
            }

            tempCartItem.addingInFlight = true;
            jQuery.getJSON('/cart.js', function(cart) {
                if(cart.item_count == 0) {
                    Shopify.addItem(variantvalue, 1, function(){
                        tempCartItem.addingInFlight = false;
                        tempCartItem.variantId = variantvalue;
                        // rede de segurança: se o polling nunca terminar de verdade
                        // por algum motivo, não deixa o item preso pra sempre
                        tempCartItem.failsafeTimer = setTimeout(removeTempCartItem, 15000);
                        carregaFrete($('#address_zip').val());
                    });
                }else {
                    tempCartItem.addingInFlight = false;
                    carregaFrete($('#address_zip').val());
                }
            }).fail(function() {
                tempCartItem.addingInFlight = false;
            });
        }else {
            carregaFrete($('#address_zip').val());
        }
    });
})
